import { FormikInput } from '@/components/common';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib';
import { Formik } from 'formik';
import { Loader2 } from 'lucide-react';
import { useUserInfo } from './hook';

const StepUser = ({ isCuriobit }: any) => {
  const { initialValues, userInfoValidationSchema, onSubmit, loading } =
    useUserInfo();
  return (
    <div className='flex flex-col gap-6 px-6 pb-6'>
      <div>
        <p className='text-center text-2xl font-bold'>
          Enter your phone number
        </p>
        <p className='text-center text-sm font-semibold text-gray-500'>
          If you don’t have an account yet, we’ll create one for you.
        </p>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={userInfoValidationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => {
          return (
            <>
              <FormikInput
                name={'name'}
                placeholder='Enter Name'
                type={'text'}
              />
              <FormikInput
                name={'email'}
                placeholder='Enter Email'
                type={'email'}
              />
              <Button
                className={cn('w-full rounded-lg p-5', isCuriobit ? "text-black bg-gradient-to-r from-yellow-400 via-amber-500 to-orange-500 " : "bg-primary text-white")}
                onClick={() => {
                  if (!loading) {
                    handleSubmit();
                  }
                }}
                disabled={loading}
                type='submit'
              >
                {loading ? <Loader2 className='animate-spin' /> : 'Continue'}
              </Button>
            </>
          );
        }}
      </Formik>
    </div>
  );
};

export default StepUser;
